.root {
  background-color: rgb(var(--color-white));
  position: sticky;
  top: 0;
  z-index: 10;
} 

.root.stuck { 
  transition: 150ms ease top;
  top: var(--header-height);
} 

.wrapper {
  /* border-top: 1px solid rgb(var(--color-gray-200));
  border-bottom: 1px solid rgb(var(--color-gray-200)); */
  position: relative;
} 

.root.stuck .wrapper {
  border-top-color: transparent;
  border-bottom-color: transparent;
}

@media(max-width:767px){
  .innerTray {
    position: relative;
    overflow: scroll;
    max-height: 70vh;
  }
}


:global(.shopify-section-header-hidden) ~ * .root {
  top: 0; 
} 

.option {
  display: flex; 
}

.option {
  font-size: 1rem;
  line-height: 1rem; 
  padding: 1rem; 
  display: flex;
  align-items: center;
  cursor: pointer;
}

.option input {
  margin-right: 1rem;
}

.root.stuck .list {
  border-top-color: transparent;
  border-bottom-color: transparent;
}

.list {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  overscroll-behavior-x: contain;
  margin-left: -1rem;
  margin-right: -1rem;
  padding: 1rem 0;
  gap: 8px;
}

@media (min-width: 768px) {
  .list > *:first-child {
    margin-left: 0;
  }

  .list {
    margin-left: 0;
    margin-right: 0;
  }
}

.accordion {
  position: relative;
  display: flex;
  flex-direction: column;
}

.accordion + .accordion .accordionButton {
  border-top-width: 1px;
}

.accordionButton {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  margin: 0 1rem;
}

.accordionButtonLabel {
  text-align: left;
  text-transform: capitalize;
}

.accordionButtonLabel *:first-child {
  font-weight: 700;
}

.accordion.open .accordionButtonLabel *:last-child {
  display: none;
}

.accordionPanel {
  display: none;
}

.accordion.open .accordionPanel {
  display: initial;
}

.dropdown {
  position: relative;
}

.dropdown.open .dropdownButton,
.dropdown.selected .dropdownButton {
  background: rgb(var(--color-gray-900));
  border-color: rgb(var(--color-gray-900));
  color: rgb(var(--color-white));
}

.count {
  font-size: 0.875rem;
  line-height: 1rem;
  border-radius: 0.25rem;
  background-color: rgb(var(--color-gray-700));
  padding: 0 0.25rem;
}

.dropdownButton {
  text-transform: initial;
}

.dropdownButton:hover {
  background: rgb(var(--color-gray-100));
}

.dropdownButton:active {
  background: rgb(var(--color-gray-200));
}

.dropdownButtonLabel {
  margin-right: 0.5rem;
}

.dropdownButtonLabel > * + * {
  margin-left: 0.5rem;
}

.dropdownPanel {
  visibility: hidden;
  position: absolute;
  top: calc(100% + 0.5rem);
  left: 0;
  width: 14rem;
  border-radius: 0.125rem;
  display: flex;
  flex-direction: column;
  background: rgb(var(--color-white));
  padding: 1rem 0;
  z-index: 1;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 4px 12px rgba(0, 0, 0, 0.1);
  max-height: 400px;
  overflow-y: auto;
}

.dropdown.open .dropdownPanel {
  visibility: visible;
}

.drawerWrapper::before {
  content: "";
  position: fixed;
  visibility: hidden;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.3);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: visibility 150ms ease, opacity 150ms ease;
}

.drawerWrapper.open::before {
  visibility: visible;
  opacity: 1;
  transition: visibility 300ms ease, opacity 300ms ease;
}

.drawer {
  position: fixed;
  visibility: hidden;
  left: 0;
  width: 100%;
  bottom: 0;
  height: 600px;
  max-height: 80vh;
  background: rgb(var(--color-white));
  transform: translateY(100%);
  transition: transform 300ms ease, visibility 300ms ease;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
}

.drawerWrapper.open .drawer {
  visibility: visible;
  transform: translateY(0);
}

.drawerButtons {
  background-color: rgb(var(--color-white));
  margin-top: auto;
  position: sticky;
  bottom: 0;
  padding: 1rem;
  border-top-width: 1px;
}

.drawerHeading {
  display: flex;
  align-items: center;
}

.drawerHeading h2 {
  margin-left: 3rem;
  text-align: center;
  flex: 1;
  text-transform: uppercase;
}

.drawerHeading button {
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sortSelect {  
  position: relative;
}

.sortSelect {
  text-align: center;
}

.sortSelect select {
  opacity: 0;
  top: 0;
  left: 0;
  line-height: 4rem;
  height: 4rem;
  width: 100%;
  position: absolute;
}

.backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.6);
  opacity: 0;
  visibility: hidden;
  z-index: 99999999;
  transition: opacity 150ms ease-in-out, visibility 150ms;
}

.backdrop.open {
  opacity: 1;
  visibility: visible;
  transition: opacity 300ms ease-in-out, visibility 300ms;
}

.refinementButton {
  color: rgb(var(--color-foreground));
  background-color: rgb(var(--color-gray-100));
  border-color: rgb(var(--color-gray-100));
  border-radius: 100px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  text-transform: initial;
  font-size: 0.875rem;
  line-height: 0.875rem;
  padding: 0.5rem 1rem;
  border-width: 1px;
  font-weight: 700;
  white-space: nowrap;
}

.refinementButton > * + * {
  margin-left: 0.5rem;
}

.refinementButton.open {
  color: rgb(var(--color-white));
  border-color: rgba(var(--color-gray-900, 0.15));
  background-color: rgba(var(--color-gray-900, 0.15));
}

.refinementMenuList {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 50vh;
  position: relative;
  /* --top-shadow: inset 0 16px 16px -16px rgba(0 0 0 / 15%);
  --bottom-shadow: inset 0 -16px 16px -16px rgba(0 0 0 / 15%);
  box-shadow: var(--top-shadow), var(--bottom-shadow); */
}

.refinementMenuButton {
  padding: 1rem;
  border-top-width: 1px;
}

.refinementMenuHeader {
  font-weight: 700;
  padding: 1rem 1rem 1rem; 
}
.refinementMenu {
  position: relative;  
} 

.applyFiltersWrapper {
  background:rgba(var(--color-white),1);
  position: sticky;
  bottom: 0;
  width: 100%;
  padding: 1rem;
  box-shadow: 0 -8px 10px -5px #00000029;
  transition: all 300ms ease;
}

.applyFiltersWrapper.shadowDisabled {
  box-shadow: unset;
}

.applyFiltersButton {
  text-align:center;
  padding:1rem;
  background: rgb(var(--color-gray-900));
  border-radius:100px;
  position: sticky;
  bottom:1rem;
  width:calc(100% - 2rem);
  margin:0 auto;
}

.disabled {
  background-color: #B9B9BA;
  pointer-events: none;
}

.applyFiltersButton button {
  font-weight:700;
  text-transform: uppercase;
  color: rgb(var(--color-white));
}

@media (max-width: 639px) {  
  .refinementMenu {    
    z-index: 99999999;  
    position: relative; 
    left: 0;
    right: 0;
    bottom: 0;
    max-height: 90vh; 
    transform: translate3d(0, 100%, 0);
    background-color: rgb(var(--color-white));
    transition: transform 300ms ease-in-out, visibility 300ms;
    padding-bottom: env(safe-area-bottom-inset)
  } 
 
  .refinementMenu.open {
    transition: transform 300ms ease-in-out;
    transform: translate3d(0, 0, 0);
    visibility: visible;
    border-radius: 16px 16px 0 0;
  } 
}

@media (min-width: 768px) {  
  .backdrop { 
    display: none;  
  } 
}
@media (min-width: 640px) {
  .refinementMenu {
    background-color: rgb(var(--color-white));
    z-index: 11;
    max-width: 320px;
    min-width: 240px;
    border-radius: 4px;
  }

  .refinementMenu.open {
    visibility: visible;
  }

  .refinementMenuCloseButton {
    display: none;
  }

  .refinementMenuList {
    padding-right: 1rem;
    max-height: 25vh;
  }

  .refinementMenuButton {
    padding-top: 1rem;
  }
}
 